module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./StoreLicenseView.js"));
	}, "StoreLicenseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreLicenseView!./src/pages/Register/StoreLicense/StoreLicenseView.js
// module id = 1753
// module chunks = 367